export const state = () => ({
    job_post: null,
    detailing_job: null,
    categorize_job: null,
    describe_job: null,
    requirements: null,
    wage_structure: null,
    candidates: null,
    jobs_nav_switch: true,
    candidates_nav_switch: false,
    allshortlist_nav_switch: false,
});
export const mutations = {
    setJobPost(state: any, payload: any) {
        state.job_post = payload;
    },

    setJobsNavSwitch(state: any, payload: any) {
        state.jobs_nav_switch = payload;
    },

    setCandidatesNavSwitch(state: any, payload: any) {
        state.candidates_nav_switch = payload;
    },

    setJobCandidates(state: any, payload: any) {
        state.candidates = payload;
    },

    setallShortlistNavSwitch(state: any, payload: any) {
        state.allshortlist_nav_switch = payload;
    },

    // setDetailingJob(state: any, payload: any) {
    // 	state.detailing_job = payload;
    // },
    // setCategorizeJob(state: any, payload: any) {
    // 	state.categorize_job = payload;
    // },
    // setDescribeJob(state: any, payload: any) {
    // 	state.describe_job = payload;
    // },
    // setRequirements(state: any, payload: any) {
    // 	state.requirements = payload;
    // },
    // setWageStructure(state: any, payload: any) {
    // 	state.wage_structure = payload;
    // },
};
export const getters = {
    getSingleJob: (state: any) => state.job_post,
    getJobsNavSwitch: (state: any) => state.jobs_nav_switch,
    getCandidatesNavSwitch: (state: any) => state.candidates_nav_switch,
    getCandidates: (state: any) => state.candidates,
    getallShortlistNavSwitch: (state: any) => state.allshortlist_nav_switch,
    // getJobPost: (state: any) => state.create_job,
    // getDetailingJob: (state: any) => state.detailing_job,
    // getCategorizeJob: (state: any) => state.categorize_job,
    // getDescribeJob: (state: any) => state.describe_job,
    // getRequirements: (state: any) => state.requirements,
    // getWageStructure: (state: any) => state.wage_structure,
};
export const actions = {
    getSingleJob(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/jobs/single/' + payload)
                .then((res) => {
                    state.commit('setJobPost', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    extendJobPost(state: any, payload: any) {
        const { job_uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_uuid}/extend`, data)
                .then((res) => {
                    this.$gtm.push({
                        event: 'extendedJob',
                        job_id: res.data.uuid,
                        job_title: res.data.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });

                    state.commit('setJobPost', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    duplicateJobPost(state: any, job_uuid: string) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_uuid}/duplicate`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteJobPost(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete('/api/jobs/' + payload)
                .then((res) => {
                    this.$gtm.push({
                        event: 'deletedJob',
                        job_id: state.state.job_post.uuid,
                        job_title: state.state.job_post.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    publishJobPost(state: any, payload: any) {
        const { job_uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_uuid}/publish`, data)
                .then((res) => {
                    this.$gtm.push({
                        event: 'publishedJob',
                        job_id: res.data.uuid,
                        job_title: res.data.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });

                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateJobDescription(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .patch(`/api/jobs/${state.state.job_post.uuid}/update-description`, payload)
                .then((res) => {
                    state.commit('setJobPost', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    getCandidates(state: any, payload: any) {
        if (state.state.allshortlist_nav_switch === true) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/jobs/' + payload + '/applications', {
                        params: { favourite: 1 },
                    })
                    .then((res) => {
                        state.commit('setJobCandidates', res.data.data);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/jobs/' + payload + '/applications', {
                        params: { favourite: 0 },
                    })
                    .then((res) => {
                        state.commit('setJobCandidates', res.data.data);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },

    toggleApplicant(state: any, payload: any) {
        let candidates = JSON.parse(JSON.stringify(state.state.candidates));
        candidates.find((can) => {
            if (can.uuid === payload) {
                can.favourite = !can.favourite;
            }
        });

        state.commit('setJobCandidates', candidates);

        return new Promise((resolve, reject) => {
            this.$axios
                .put('/api/jobs/applications/' + payload + '/shortlist-toggle')
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    toggleShortList(state: any, payload: any) {
        state.commit('setallShortlistNavSwitch', payload);
    },

    updateJobsNavSwitch(state: any, payload: any) {
        state.commit('setJobsNavSwitch', payload);
    },

    updateCandidatesNavSwitch(state: any, payload: any) {
        state.commit('setCandidatesNavSwitch', payload);
    },

    updateCandidates(state: any, payload: any) {
        state.commit('setJobCandidates', payload);
    },
    updateJobPost(state: any, payload: any) {
        state.commit('setJobPost', payload);
    },

    // updateDetailingJob(state: any, payload: any) {
    // 	state.commit('setDetailingJob', payload);
    // },
    // updateCategorizeJob(state: any, payload: any) {
    // 	state.commit('setCategorizeJob', payload);
    // },
    // updateDescribeJob(state: any, payload: any) {
    // 	state.commit('setDescribeJob', payload);
    // },
};
